import { render, staticRenderFns } from "./DashboardCreatePostingModal.vue?vue&type=template&id=52bba910"
import script from "./DashboardCreatePostingModal.vue?vue&type=script&lang=js"
export * from "./DashboardCreatePostingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports